import { i18n } from '@group-link-one/grouplink-components';
import { subDays } from 'date-fns';
import { createWithEqualityFn } from 'zustand/traditional';
import { UserEventResponse } from '@/Services/userEventsService/userEventServices.types';
import { UserEvent } from '../PointModal/Cards/Events/UserEvents.types';

export interface UserEventsStoreState {
  eventListModalIsOpen: boolean;
  deviceModalIsOpen: boolean;
  deviceSelected: UserEventResponse | undefined;
  pointModalIsOpen: boolean;
  pointSelected: UserEvent | undefined;
  isFetchingDeviceInfo: boolean;
}

export interface UserEventsStoreActions {
  setDeviceModalIsOpen: (deviceModalIsOpen: boolean) => void;
  setDeviceSelected: (deviceSelected?: UserEventResponse) => void;
  setPointModalIsOpen: (pointModalIsOpen: boolean) => void;
  setPointSelected: (pointSelected?: UserEvent) => void;
  setIsEventListModalOpen: (eventListModalIsOpen: boolean) => void;
  setIsFetchingDeviceInfo: (isFetchingDeviceInfo: boolean) => void;
  resetAll: () => void;
}

export interface UserEventsStore {
  state: UserEventsStoreState;
  actions: UserEventsStoreActions;
}

export const useUserEventsStore = createWithEqualityFn<UserEventsStore>(
  (set) => ({
    state: {
      deviceModalIsOpen: true,
      pointModalIsOpen: false,
      deviceSelected: undefined,
      pointSelected: undefined,
      eventListModalIsOpen: false,
      isFetchingDeviceInfo: false,
    },
    actions: {
      setDeviceModalIsOpen: (deviceModalIsOpen) =>
        set((state) => ({
          state: {
            ...state.state,
            deviceModalIsOpen,
          },
        })),

      setDeviceSelected: (deviceSelected) =>
        set((state) => ({
          state: {
            ...state.state,
            deviceSelected,
          },
        })),

      setPointModalIsOpen: (pointModalIsOpen) =>
        set((state) => ({
          state: {
            ...state.state,
            pointModalIsOpen,
          },
        })),

      setPointSelected: (pointSelected) =>
        set((state) => ({
          state: {
            ...state.state,
            pointSelected,
          },
        })),

      setIsFetchingDeviceInfo: (isFetchingDeviceInfo) =>
        set((state) => ({
          state: {
            ...state.state,
            isFetchingDeviceInfo,
          },
        })),

      setIsEventListModalOpen: (eventListModalIsOpen) =>
        set((state) => ({
          state: {
            ...state.state,
            eventListModalIsOpen,
          },
        })),

      resetAll: () =>
        set((state) => ({
          state: {
            ...state.state,
            deviceModalIsOpen: false,
            deviceSelected: undefined,
            devicesFetched: undefined,
            alertFilterValue: [{ id: 'all', text: 'Todos' }],
            alertTypesSelected: undefined,
            isFetchingDevices: false,
            currentDateRange: undefined,
            currentRelativeTime: {
              id: 'last_7_days',
              range: {
                from: subDays(new Date(), 7),
                to: new Date(),
              },
              text: i18n.t('days.last7Days'),
            },
            geo_filter: undefined,
            range: {
              from: subDays(new Date(), 7),
              to: new Date(),
            },
          },
        })),
    },
  }),
);
